import { IExecutionOptions, IQueryOptions } from '../../models/query';
import { BaseTransform } from './BaseTransform';
import { Query } from '../Query';
import { isNumber } from '../../utils/number';

export class NumberTransform extends BaseTransform {
	execute(queryResponse: any, queryOptions: IQueryOptions, executionOptions: IExecutionOptions) {
		if (queryResponse && isNumber(queryResponse)) {
			const { numberOptions } = this.options;
			if (numberOptions && numberOptions.operator) {
				let value = numberOptions.value;
				if (numberOptions.valueQuery) {
					const valueQuery = new Query(numberOptions.valueQuery);
					value = valueQuery.execute(executionOptions);
				}
				try {
					switch (numberOptions.operator) {
						case 'multiply':
							return queryResponse * value;
						case 'divide':
							return queryResponse / value;
						case 'add':
							return queryResponse + value;
						case 'subtract':
							return queryResponse - value;
						default:
							return queryResponse;
					}
				}
				catch (ex) {
					console.warn(`Error while performing NumberTransform, queryResponse: ${queryResponse}, operator: ${numberOptions.operator}, value: ${value}, error: `, ex);
				}
			}
		}
		return queryResponse;
	}
}
